import { Models } from '@rematch/core';

import { alerts } from './alerts';
import { auth } from './auth';
import { coverImages } from './coverImages';
import { distribution } from './distribution';
import { filters } from './filters';
import { layout } from './layout';
import { navigationCounter } from './navigationCounter';
import { options } from './options';
import { teams } from './teams';
import { toasts } from './toasts';
import { viewGuides } from './viewGuides';

export interface RootModel extends Models<RootModel> {
  auth: typeof auth;
  alerts: typeof alerts;
  toasts: typeof toasts;
  teams: typeof teams;
  options: typeof options;
  navigationCounter: typeof navigationCounter;
  viewGuides: typeof viewGuides;
  layout: typeof layout;
  distribution: typeof distribution;
  coverImages: typeof coverImages;
  filters: typeof filters;
}

export const models: RootModel = {
  toasts,
  auth,
  alerts,
  teams,
  options,
  navigationCounter,
  viewGuides,
  layout,
  distribution,
  coverImages,
  filters,
};
